import { Button } from '@cimplico/components';
import * as Sentry from '@sentry/react';
import { ReactNode } from 'react';

type ErrorBoundaryProps = {
    children: ReactNode | ReactNode[];
};

function ErrorBoundary({ children }: ErrorBoundaryProps): JSX.Element {
    return (
        <Sentry.ErrorBoundary
            fallback={({ resetError }): JSX.Element => {
                return (
                    <div className="w-full h-full flex items-center justify-center flex-col gap-4 mt-16">
                        <p className="text-lg text-gray-600">Something went wrong!</p>
                        <Button type="secondary" label="Try Again" onClick={resetError} />
                        <p className="text-gray-500 text-sm">We have been notified of the problem.</p>
                    </div>
                );
            }}
        >
            {children}
        </Sentry.ErrorBoundary>
    );
}
export default ErrorBoundary;
